import React, { useState, useEffect, useRef } from 'react';
import RecipeList from './RecipeList';

/* ── FIX: buscador de insumos con filtro en tiempo real ── */
const SupplySearchSelect = ({ supplies, value, onChange, index }) => {
  const [search, setSearch] = useState('');
  const [open, setOpen]     = useState(false);
  const ref                 = useRef(null);

  const selected = supplies.find(s => s.id?.toString() === value?.toString());

  const filtered = search.trim() === ''
    ? supplies
    : supplies.filter(s => s.name?.toLowerCase().includes(search.toLowerCase()));

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setSearch('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div
        onClick={() => setOpen(v => !v)}
        style={{
          width: '100%', padding: '8px 12px',
          border: '1px solid #58735A', borderRadius: '6px',
          background: '#F9EFD7', color: '#3F1907',
          cursor: 'pointer', fontSize: '14px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}
      >
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {selected ? selected.name : 'Selecciona un insumo'}
        </span>
        <span style={{ fontSize: '10px', opacity: 0.6, flexShrink: 0, marginLeft: '6px' }}>
          {open ? '▲' : '▼'}
        </span>
      </div>

      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0,
          background: '#F9EFD7', border: '1px solid #58735A',
          borderRadius: '6px', zIndex: 999,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          maxHeight: '260px', display: 'flex', flexDirection: 'column'
        }}>
          <div style={{ padding: '8px' }}>
            <input
              autoFocus
              type="text"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Buscar insumo..."
              onClick={e => e.stopPropagation()}
              style={{
                width: '100%', padding: '6px 10px',
                border: '1px solid #58735A', borderRadius: '4px',
                background: 'white', color: '#3F1907',
                fontSize: '13px', boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ overflowY: 'auto', maxHeight: '200px' }}>
            {filtered.length === 0 ? (
              <div style={{ padding: '10px 12px', fontSize: '13px', color: '#888' }}>
                Sin resultados
              </div>
            ) : (
              filtered.map(s => (
                <div
                  key={s.id}
                  onClick={() => {
                    onChange(index, 'supplyId', s.id.toString());
                    setOpen(false);
                    setSearch('');
                  }}
                  style={{
                    padding: '8px 12px', fontSize: '13px', color: '#3F1907',
                    cursor: 'pointer',
                    background: s.id?.toString() === value?.toString() ? '#d4e6d5' : 'transparent',
                    borderBottom: '0.5px solid #e0d8c8'
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#e8f0e8'}
                  onMouseLeave={e => e.currentTarget.style.background =
                    s.id?.toString() === value?.toString() ? '#d4e6d5' : 'transparent'}
                >
                  <span style={{ fontWeight: s.id?.toString() === value?.toString() ? '500' : '400' }}>
                    {s.name}
                  </span>
                  <span style={{ fontSize: '11px', color: '#888', marginLeft: '6px' }}>
                    {s.unit}
                  </span>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

/* ── CostingPage ── */
const CostingPage = ({ menuItems = [], categories = [], supplies = [], recipes = [], onSaveRecipe, onDeleteRecipe, onUpdateRecipe }) => {

  const [editingRecipeId, setEditingRecipeId]     = useState(null);
  const [selectedProduct, setSelectedProduct]     = useState('');
  const [selectedCategory, setSelectedCategory]   = useState('');
  const [servings, setServings]                   = useState(1);
  const [ingredients, setIngredients]             = useState([{ supplyId: '', quantity: 0 }]);
  const [recipeName, setRecipeName]               = useState('');
  const [realPriceWithoutVAT, setRealPriceWithoutVAT] = useState(0);
  const [recipesList, setRecipesList]             = useState(recipes);
  const [isSaving, setIsSaving]                   = useState(false);

  const safeNumber = (value) => {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  };

  const loadRecipes = async () => {
    try {
      const response = await fetch("/api/list_recipes.php");
      const result   = await response.json();
      if (result.success) {
        setRecipesList(result.recipes || result.data || []);
      }
    } catch (error) {
      console.error("Error cargando recetas:", error);
    }
  };

  useEffect(() => { loadRecipes(); }, []);
  useEffect(() => { setRecipesList(recipes); }, [recipes]);

  useEffect(() => {
    const product = Array.isArray(menuItems)
      ? menuItems.find(item => item.id?.toString() === selectedProduct?.toString())
      : null;

    setRealPriceWithoutVAT(
      product
        ? safeNumber(product.priceWithoutVAT ?? product.price_without_vat ?? product.price)
        : 0
    );
  }, [selectedProduct, menuItems]);

  const handleProductChange = (e) => {
    const productId = e.target.value.toString();
    setSelectedProduct(productId);

    const product = Array.isArray(menuItems)
      ? menuItems.find(item => item.id?.toString() === productId)
      : null;

    if (product) {
      setSelectedCategory((product.categoryId ?? product.category_id ?? '').toString());
      if (!editingRecipeId) setRecipeName(product.name ?? '');
    } else {
      setSelectedCategory('');
      if (!editingRecipeId) setRecipeName('');
    }
  };

  const handleServingsChange    = (e) => setServings(Number(e.target.value) || 1);
  const handleAddIngredient     = () => setIngredients([...ingredients, { supplyId: '', quantity: 0 }]);
  const handleRemoveIngredient  = (index) => setIngredients(ingredients.filter((_, i) => i !== index));

  const handleIngredientChange = (index, field, value) => {
    const updated = [...ingredients];
    updated[index] = {
      ...updated[index],
      [field]: field === 'quantity' ? Number(value) : value
    };
    setIngredients(updated);
  };

  const getSupplyDetails = (supplyId) => {
    const supply = Array.isArray(supplies)
      ? supplies.find(s => s.id?.toString() === supplyId?.toString())
      : null;

    if (!supply) return { name: "Insumo eliminado", unit: "-", unitCost: 0, deleted: true };

    return {
      ...supply,
      unitCost: safeNumber(supply.unitCost ?? supply.unit_cost ?? supply.cost ?? 0)
    };
  };

  const calculateTotalCost = () =>
    ingredients.reduce((total, ingredient) => {
      const supply = getSupplyDetails(ingredient.supplyId);
      return total + (supply.unitCost || 0) * safeNumber(ingredient.quantity);
    }, 0);

  const totalCost              = calculateTotalCost();
  const costPerServing         = servings > 0 ? totalCost / servings : 0;
  const theoreticalPVPPerServing = costPerServing > 0 ? costPerServing / 0.30 : 0;
  const theoreticalPVPTotal    = totalCost > 0 ? totalCost / 0.30 : 0;
  const realPVPPerServing      = realPriceWithoutVAT;
  const realPVPTotal           = realPVPPerServing * servings;
  const marginPerServing       = realPVPPerServing - costPerServing;
  const totalMargin            = realPVPTotal - totalCost;
  const totalProfitPercentage  = realPVPTotal > 0 ? (totalMargin / realPVPTotal) * 100 : 0;
  const recipeCostPercentage   = realPVPTotal > 0 ? (totalCost / realPVPTotal) * 100 : 0;

  const isBadMargin    = totalProfitPercentage < 50;
  const isDangerMargin = totalProfitPercentage < 30;

  const handleSaveRecipe = async () => {
    if (isSaving) return;
    setIsSaving(true);

    if (!selectedProduct || !recipeName) {
      alert('Selecciona producto y nombre.');
      setIsSaving(false);
      return;
    }

    if (ingredients.length === 0 || ingredients.some(ing => !ing.supplyId || ing.quantity <= 0)) {
      alert('Ingredientes inválidos.');
      setIsSaving(false);
      return;
    }

    const recipeData = {
      id: editingRecipeId,
      name: recipeName,
      productId: selectedProduct,
      categoryId: selectedCategory,
      servings,
      ingredients: ingredients.map(ing => ({ supplyId: ing.supplyId, quantity: ing.quantity })),
      totalCost, costPerServing, theoreticalPVPPerServing, theoreticalPVPTotal,
      realPVPPerServing, realPVPTotal, marginPerServing, totalMargin,
      totalProfitPercentage, recipeCostPercentage
    };

    try {
      const url = editingRecipeId ? "/api/update_recipe.php" : "/api/save_recipe.php";
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(recipeData)
      });
      const result = await response.json();

      if (!result.success) {
        alert(result.error || "Error guardando receta");
        setIsSaving(false);
        return;
      }

      await loadRecipes();
      alert(editingRecipeId ? "Receta actualizada" : "Receta guardada");
      handleNewRecipe();

    } catch (error) {
      console.error(error);
      alert("Error servidor");
    } finally {
      setIsSaving(false);
    }
  };

  const handleNewRecipe = () => {
    setEditingRecipeId(null);
    setSelectedProduct('');
    setSelectedCategory('');
    setServings(1);
    setIngredients([{ supplyId: '', quantity: 0 }]);
    setRecipeName('');
  };

  const handleEditRecipe = (recipe) => {
    setEditingRecipeId(recipe.id);
    setRecipeName(recipe.name);
    setSelectedProduct((recipe.productId ?? recipe.product_id ?? '').toString());
    setSelectedCategory((recipe.categoryId ?? recipe.category_id ?? '').toString());
    setServings(recipe.servings ?? 1);
    setIngredients(
      Array.isArray(recipe.ingredients)
        ? recipe.ingredients.map(ing => ({
            supplyId: (ing.supplyId ?? ing.supply_id)?.toString(),
            quantity: ing.quantity
          }))
        : [{ supplyId: '', quantity: 0 }]
    );
  };

  return (
    <div className="mt-6">
      <div className="bg-[#F9EFD7] p-4 rounded-lg shadow">
        <h3 className="text-lg font-semibold text-[#3F1907] mb-3">
          {editingRecipeId ? 'Editar Receta' : 'Costeo del Menú'}
        </h3>

        {/* NOMBRE */}
        <div className="mb-4">
          <label className="block text-[#3F1907] text-sm font-bold mb-1">Nombre de la Receta</label>
          <input
            type="text" value={recipeName}
            onChange={(e) => setRecipeName(e.target.value)}
            className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
            placeholder="Nombre descriptivo para la receta"
          />
        </div>

        {/* PRODUCTO / CATEGORÍA / RACIONES */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div>
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Producto</label>
            <select
              value={selectedProduct} onChange={handleProductChange}
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
            >
              <option value="">Selecciona un producto</option>
              {Array.isArray(menuItems) && menuItems.map(item => (
                <option key={item.id} value={item.id}>{item.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Categoría</label>
            <input
              type="text"
              value={categories.find(cat => cat.id?.toString() === selectedCategory)?.name || ''}
              readOnly
              className="w-full px-3 py-2 border border-[#58735A] rounded-md bg-[#F9EFD7] text-[#3F1907]"
            />
          </div>

          <div>
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Número de Raciones</label>
            <input
              type="number" min="1" step="1" value={servings}
              onChange={handleServingsChange}
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
            />
          </div>
        </div>

        {/* INSUMOS */}
        <h4 className="text-md font-semibold text-[#3F1907] mb-3">Insumos Utilizados</h4>
        {ingredients.map((ingredient, index) => {
          const supply = getSupplyDetails(ingredient.supplyId);
          return (
            <div key={index} className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-3">
              <div>
                <label className="block text-[#3F1907] text-sm font-bold mb-1">Insumo</label>
                {/* FIX: buscador en lugar de select */}
                <SupplySearchSelect
                  supplies={supplies}
                  value={ingredient.supplyId}
                  onChange={handleIngredientChange}
                  index={index}
                />
              </div>

              <div>
                <label className="block text-[#3F1907] text-sm font-bold mb-1">Cantidad</label>
                <input
                  type="number" min="0" step="0.01" value={ingredient.quantity}
                  onChange={(e) => handleIngredientChange(index, 'quantity', e.target.value)}
                  className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
                />
              </div>

              <div>
                <label className="block text-[#3F1907] text-sm font-bold mb-1">Unidad</label>
                <input
                  type="text" value={supply.unit || ''} readOnly
                  className="w-full px-3 py-2 border border-[#58735A] rounded-md bg-[#F9EFD7] text-[#3F1907]"
                />
              </div>

              <div>
                <label className="block text-[#3F1907] text-sm font-bold mb-1">Costo Unitario</label>
                <input
                  type="text"
                  value={supply.unitCost ? `$${supply.unitCost.toFixed(2)}` : ''}
                  readOnly
                  className="w-full px-3 py-2 border border-[#58735A] rounded-md bg-[#F9EFD7] text-[#3F1907]"
                />
              </div>

              <div className="flex items-end">
                <button
                  type="button" onClick={() => handleRemoveIngredient(index)}
                  className="w-full bg-red-500 hover:bg-red-600 text-[#F9EFD7] font-medium py-2 px-4 rounded-md transition duration-200"
                >
                  Eliminar
                </button>
              </div>
            </div>
          );
        })}

        {/* BOTONES Y COSTOS */}
        <div className="flex justify-between items-center mt-4">
          <div className="space-x-2">
            <button
              type="button" onClick={handleAddIngredient}
              className="bg-[#58735A] hover:bg-[#3F1907] text-[#F9EFD7] font-medium py-2 px-4 rounded-md transition duration-200"
            >
              Agregar Insumo
            </button>
            <button
              type="button" onClick={handleNewRecipe}
              className="bg-gray-500 hover:bg-gray-600 text-[#F9EFD7] font-medium py-2 px-4 rounded-md transition duration-200"
            >
              Nueva Receta
            </button>
          </div>

          <div className="text-right space-y-2">
            <div>
              <p className="text-sm text-[#3F1907]">Costo Total:</p>
              <p className="text-xl font-bold text-[#3F1907]">${totalCost.toFixed(2)}</p>
            </div>
            <div>
              <p className="text-sm text-[#3F1907]">Costo por Ración:</p>
              <p className="text-xl font-bold text-[#3F1907]">${costPerServing.toFixed(2)}</p>
            </div>
            <div>
              <p className="text-sm text-[#3F1907]">P.V.P. Teórico por Ración:</p>
              <p className="text-xl font-bold text-[#3F1907]">${theoreticalPVPPerServing.toFixed(2)}</p>
            </div>
            <div>
              <p className="text-sm text-[#3F1907]">P.V.P. Teórico Total:</p>
              <p className="text-xl font-bold text-[#3F1907]">${theoreticalPVPTotal.toFixed(2)}</p>
            </div>
            <div>
              <p className="text-sm text-[#3F1907]">P.V.P. Real por Ración (sin IVA):</p>
              <p className="text-xl font-bold text-[#3F1907]">${realPVPPerServing.toFixed(2)}</p>
            </div>
            <div>
              <p className="text-sm text-[#3F1907]">P.V.P. Real Total:</p>
              <p className="text-xl font-bold text-[#3F1907]">${realPVPTotal.toFixed(2)}</p>
            </div>
            <div>
              <p className="text-sm text-[#3F1907]">Margen de Utilidad por Ración:</p>
              <p className="text-xl font-bold text-[#3F1907]">${marginPerServing.toFixed(2)}</p>
            </div>
            <div>
              <p className="text-sm text-[#3F1907]">Margen de Utilidad Total:</p>
              <p className="text-xl font-bold text-[#3F1907]">${totalMargin.toFixed(2)}</p>
            </div>
            <div>
              <p className="text-sm text-[#3F1907]">Porcentaje de Utilidad Total:</p>
              <p className={`text-xl font-bold ${isDangerMargin ? 'text-red-600' : isBadMargin ? 'text-yellow-600' : 'text-green-600'}`}>
                {totalProfitPercentage.toFixed(2)}%
              </p>
            </div>
            <div>
              <p className="text-sm text-[#3F1907]">Porcentaje de Costo de la Receta:</p>
              <p className="text-xl font-bold text-[#3F1907]">{recipeCostPercentage.toFixed(2)}%</p>
            </div>

            <button
              type="button" onClick={handleSaveRecipe}
              className="bg-green-600 hover:bg-green-700 text-[#F9EFD7] font-medium py-2 px-4 rounded-md transition duration-200 ml-4"
              disabled={isSaving || !selectedProduct || !recipeName || ingredients.length === 0 || ingredients.some(ing => !ing.supplyId || ing.quantity <= 0)}
            >
              {isSaving ? "Guardando..." : editingRecipeId ? 'Actualizar Receta' : 'Guardar Receta'}
            </button>
          </div>
        </div>
      </div>

      <RecipeList
        recipes={recipesList}
        onDelete={onDeleteRecipe}
        onEdit={handleEditRecipe}
        menuItems={menuItems}
        supplies={supplies}
      />
    </div>
  );
};

export default CostingPage;